import { render } from "./CustomFlagImg.vue?vue&type=template&id=2d6635ae&scoped=true"
import script from "./CustomFlagImg.vue?vue&type=script&lang=js"
export * from "./CustomFlagImg.vue?vue&type=script&lang=js"

import "./CustomFlagImg.vue?vue&type=style&index=0&id=2d6635ae&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6635ae"]])

export default __exports__